import React from "react";
import { QIButton } from "../../../components";
import { SvgIcon } from "../../Shared";
import { toast, ToastContainer } from "react-toastify";
import sprite from "../../../assets/icons.svg";

export const MPEditButton = ({ onClick, ...props }) => {
  return (
    <QIButton className="me-2" onClick={onClick}>
      <SvgIcon name="edit" wrapperClass="icon-edit" />
    </QIButton>
  );
};

export const MPDeleteButton = ({ onClick, ...props }) => {
  return (
    <QIButton variant="danger" size="sm" onClick={onClick}>
      <SvgIcon name="delete" wrapperClass="icon-delete" />
    </QIButton>
  );
};

export const VideoEvidenceButton = ({ wrapperClassName, btnClassName, plateNumber, sourceTime, tooltipPosition = 'left' }) => {
  const getEvidenceDetails = async () => {
    const baseUrl = process.env.REACT_APP_EVIDENCE_DETAILS_URL
    const params = new URLSearchParams();
    params.append('PlateNumber', plateNumber);
    params.append('From', new Date(sourceTime).toISOString());
    params.append('To', new Date(sourceTime).toISOString());

    try {
      const response = await fetch(`${baseUrl}?${params.toString()}`);
      if (!response.ok) {
        throw new Error('Evidence not found');
      }

      const data = await response.json();

      if (data.length > 0) {
        window.open(data[0]?.EvidenceLink, '_blank');
      } else {
        throw new Error('Evidence not found')
      }
    } catch (error) {
      console.error(error.message);
      toast.error('Evidence is not ready yet.')
    }
  }

  return (
    <>
      <div className={`custom-tooltip custom-tooltip_${tooltipPosition} ${wrapperClassName || ''}`}>
        <QIButton className={`btn-video primary ${btnClassName || ''}`} onClick={getEvidenceDetails}>
          <svg className="icon">
            <use href={`${sprite}#video`}></use>
          </svg>
        </QIButton>
        <span className="custom-tooltip_content">View Evidence</span>
      </div>
      <ToastContainer position="bottom-right" />
    </>
  )
}
